import { render, staticRenderFns } from "./courseAdd.vue?vue&type=template&id=e0094bfc&scoped=true"
import script from "./courseAdd.vue?vue&type=script&lang=js"
export * from "./courseAdd.vue?vue&type=script&lang=js"
import style0 from "./courseAdd.vue?vue&type=style&index=0&id=e0094bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0094bfc",
  null
  
)

export default component.exports